module.exports = __webpack_public_path__ + "static/media/puzzle-32-bg.af9833bb.svg";